import React, { useContext } from "react"
import { UIContext } from "./layout"
import FadedTitle from "./faded-title"
import VisibilityProvider from "./visibility-provider"
import {
  ProjectDescriptionContainer,
  CopyContainer,
  DividingLine,
} from "./project-description.style"

export default function ProjectDescription({
  fadeSettings,
  fadeImage,
  fadeTitle,
  fadeAlt,
  children,
  styles,
  showDivider = true,
  animated = false,
}) {
  const { state: UIState } = useContext(UIContext)

  return (
    <VisibilityProvider>
      <ProjectDescriptionContainer styles={styles} animated={animated}>
        <FadedTitle
          fadeSettings={fadeSettings}
          image={fadeImage}
          title={fadeTitle}
          alt={fadeAlt}
          textAlign={UIState.breakpoint === "sm" ? "center" : "left"}
        />
        {showDivider && <DividingLine />}
        <CopyContainer>{children}</CopyContainer>
      </ProjectDescriptionContainer>
    </VisibilityProvider>
  )
}
